import { useCallback, useState } from "react";

import { SelectModeData } from "../../parts/overview/context/booking_rows_context/use_select_mode/use_select_mode";

interface BulkUpdateState {
  isOpen: boolean;
  selection: SelectModeData | null;
}

export type UseBulkUpdateType = {
  open: (selection: SelectModeData | null) => void;
  close: () => void;
  state: BulkUpdateState;
};

export const useBulkUpdate = (): UseBulkUpdateType => {
  const [formData, setFormData] = useState<BulkUpdateState>({ isOpen: false, selection: null });

  const open = useCallback(
    (selection: SelectModeData | null) => setFormData({ isOpen: true, selection: selection }),
    []
  );

  const close = useCallback(() => setFormData({ isOpen: false, selection: null }), []);

  return { open, close, state: formData };
};
